import { useDonHangSearchContext } from './search-context';
import { useDonHangTable } from './useDonHangTable';

export const useDonHangPage = () => {
  const { isExporting } = useDonHangSearchContext();
  const tableState = useDonHangTable();

  const handleSubmit = async (data: BanHangPayload) => {
    try {
      if (tableState.form.formMode === 'add') {
        await tableState.crud.addItem(data);
      } else if (tableState.form.formMode === 'edit' && tableState.selection.selectedObj) {
        await tableState.crud.updateItem(tableState.selection.selectedObj.uuid, data);
      }

      tableState.form.handleCloseForm();
      tableState.selection.clearSelection();
      await tableState.crud.refreshData();
    } catch (error) {
      return;
    }
  };

  return {
    searchDialog: tableState.searchDialog,
    formDialog: {
      open: tableState.dialogs.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.dialogs.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: tableState.form.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    deleteDialog: {
      open: tableState.dialogs.showDelete,
      onClose: tableState.form.handleCloseDelete,
      selectedObj: tableState.selection.selectedObj,
      deleteObj: tableState.crud.deleteItem,
      clearSelection: tableState.selection.clearSelection
    },
    bulkDeleteDialog: {
      open: tableState.dialogs.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: tableState.crud.deleteItem
    },
    table: tableState.table,
    detailTable: {
      rows: tableState.selection.selectedObj ? tableState.crud.detailRowsWithStock : []
    },
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleRefresh: tableState.table.onRefresh,
      handleSearch: tableState.searchDialog.onOpen
    },
    selection: {
      selectedObj: tableState.selection.selectedObj,
      selectedRowIndex: tableState.selection.selectedRowIndex
    }
  };
};
